import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { setSpeakLive } from '@/utils/audioPlayer';

export default class liveState extends baseState {
  // 直播列表
  @observable live = {};
  @action
  setLive = data => this.live = data;
  getLive = data => {
    return this.fetch({
      url: apiUrl.LIVE.LIST,
      method: 'get',
      setState: this.setLive,
      data
    });
  }

  // 正在通话的直播
  @observable speakLive = {};
  @action
  setSpeakLive = data => {
    this.speakLive = data;
    // 刷新页面也能记住之前的通话状态
    setSpeakLive(data);
  };

  // 新建直播
  addLive = data => {
    return this.fetch({
      url: apiUrl.LIVE.ADD_LIVE,
      method: 'post',
      data
    });
  }

  // 获取单路配置详情
  getDetail = id => {
    return this.fetch({
      url: apiUrl.LIVE.DETAIL + id,
      method: 'get',
    });
  }

  // 获取待添加设备列表
  @observable device = {};
  @action
  setDevice = data => this.device = data;
  getDevice = data => {
    return this.fetch({
      url: apiUrl.LIVE.DEVICE_LIST,
      method: 'get',
      setState: this.setDevice,
      data
    });
  }

  // 获取全部聚合服务器
  getAggServe = () => {
    return this.fetch({
      url: apiUrl.LIVE.AGG_SERVE,
      method: 'get',
    });
  }

  // 获取全部聚合服务器的延迟信息
  getAggServeDelay = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.AGG_DELAY.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取全部媒体服务器
  @observable meidaServe = null;
  @action
  setMeidaServe = data => this.meidaServe = data;
  getMeidaServe = data => {
    return this.fetch({
      url: apiUrl.LIVE.MEDIA_SERVE,
      method: 'get',
      setState: this.setMeidaServe,
      data,
    });
  }

  // 获取推流状态
  getPushStatus = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.PUSH_STATUS.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置推流状态
  updatePushStatus = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_PUSH_STATUS.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取编码输入源
  getParamsSource = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.PARAMS_SOURCE.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置编码输入源
  updateParamsSource = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_PARAMS_SOURCE.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取编码状态
  getParams = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.PARAMS.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置编码状态
  updateParams = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_PARAMS.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取ip信息
  getIp = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.IP_INFO.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置ip信息
  updateIp = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_IP_INFO.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取可用wifi列表
  getWifi = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.WIFI_LIST.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取已连接的wifi
  getConnectWifi = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.CONNECT_WIFI_LIST.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置已用wifi
  updateWifi = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_WIFI.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 获取聚合模式
  getAgg = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.AGG_LIST.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置聚合模式
  updateAgg = (data, id, liveId) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_AGG.replace('{id}', id).replace('{liveId}', liveId),
      data,
    });
  }

  // 设置要用的聚合服务器
  updateAggUse = (data) => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_AGG_USE,
      data,
    });
  }

  // 设置要用的媒体服务器和直播地址
  updateUse = data => {
    return this.fetch({
      url: apiUrl.LIVE.UPDATE_USE,
      data,
    });
  }

  // 获取录制文件列表
  @observable document = {};
  @action
  setDocument = data => this.document = data;
  getDocument = (data, id) => {
    return this.fetch({
      url: apiUrl.LIVE.DOCUMENT.replace('{id}', id),
      method: 'get',
      setState: this.setDocument,
      data
    });
  }

  // 删除录制文件
  delDocument = id => {
    return this.fetch({
      url: apiUrl.LIVE.DEL_DOCUMENT + id,
      data: { id }
    });
  }

  // 注销直播
  cancelLive = data => {
    return this.fetch({
      url: apiUrl.LIVE.CANCEL_LIVE,
      data
    });
  }

  // 删除直播
  delLive = id => {
    return this.fetch({
      url: apiUrl.LIVE.DEL_LIVE + id,
      data: { id }
    });
  }

  // 删除或注销前判断是否在推流
  beforeDelLive = id => {
    return this.fetch({
      url: apiUrl.LIVE.BEFORE_DEL + id,
      method: 'get',
      data: { id }
    });
  }
}
